import { MODULE } from 'constant/globals';

type ModuleKey = keyof typeof MODULE;

export const GUIDED_TOUR_MODULES: Partial<Record<ModuleKey, boolean>> = {
  USERS: true,
  EMPLOYEE: true,
  TIMESHEET: true,
  PROJECT: true,
  PURCHASE_ORDER: true,
  LEAVE: true,
  BILLS: true,
};

export const GUIDED_TOUR_CONFIG = {
  VIEW_SCAN_BILLS: {
    GUIDE_ID: '1BerfPM9L6',
    STEP_ID: '5101373',
  },
};

/**
 * Stonly `openGuide` ids for HelpButton "Get a Quick Walkthrough".
 * Set `VITE_APP_STONLY_GUIDE_PROJECT` to override (e.g. the "Need Guidance?" guide).
 * When unset, the add-project embed id is used so `openGuide` always runs (widget v2
 * does not reliably open content via `StonlyWidget('open')` alone).
 */
export const STONLY_WALKTHROUGH_GUIDE_IDS: Partial<
  Record<keyof typeof GUIDED_TOUR_MODULES, string>
> = {
  PROJECT:
    (
      import.meta.env.VITE_APP_STONLY_GUIDE_PROJECT as string | undefined
    )?.trim() || 'h66A0RdXoc',
};

/** Optional `openGuide` step id (same env prefix pattern as guide ids). */
export const STONLY_WALKTHROUGH_STEP_IDS: Partial<
  Record<keyof typeof GUIDED_TOUR_MODULES, string>
> = {
  PROJECT:
    (
      import.meta.env.VITE_APP_STONLY_GUIDE_PROJECT_STEP as string | undefined
    )?.trim() || '',
};

/**
 * Target keys for Stonly's built-in Data Transmission feature.
 *
 * In the Stonly guide editor: select a step → click the data-transmission
 * icon → set "Target" to the matching value below.
 *
 * "Value" field convention:
 *   OPEN_QUARTERZIP_AGENT — set to the Quarterzip agentId string.
 *   Leave blank to fall back to VITE_APP_QUARTERZIP_AGENT_ID env var.
 */
export const STONLY_DATA_TRANSMISSION_TARGETS = {
  OPEN_QUARTERZIP_AGENT: 'open-quarterzip-agent',
} as const;
